
console.log( 'Hello World! (from create-block-brand-values block)' );
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const columns = document.querySelectorAll(".scroll-container-width-wrapper .wp-block-column");

gsap.from(columns, {
	opacity: 0,
	y: 50,
	duration: 1.5,
	stagger: 0.3,
	ease: "power3.out",
	scrollTrigger: {
		trigger: ".scroll-container-width-wrapper", // Тригером є обгортка
		start: "top 80%", // Початок анімації, коли обгортка доходить до 80% від висоти вікна
		onEnter: (self) => self.animation.restart(), // Повторює анімацію при вході
		onEnterBack: (self) => self.animation.restart(), // Повторює анімацію при зворотному вході
	},
});
